import { getQueryParameters, getUsageParameters, getIncludeNotHeldParameter, getSimulateActionsNode, getAttributionMethodParameter, getContributorDescriptors, getAnalyticsOutputParameter } from "./helpers"

export function marginalContributorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const attributionMethodParameter = getAttributionMethodParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter, attributionMethodParameter])}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${marginalContributorsQueryFragment([includeNotHeldParameter, attributionMethodParameter])}
      }
    }
  }`
}

export function marginalContributorsQueryFragment(parameters = []) {
  return `riskContributors${getUsageParameters(parameters, true)} {
    ${getContributorDescriptors()}
    total
    exposureRiskCorrelation{
      volatility
      correlation
      marginalContribution
      riskContribution
    }
    attribution {
      exposureRiskCorrelation{
        factors{
          volatility
          correlation
          marginalContribution
          riskContribution
        }
        specific{
          volatility
          correlation
          marginalContribution
          riskContribution
        }
      }
    }
  }`
}

export function groupedMarginalContributorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const attributionMethodParameter = getAttributionMethodParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter, attributionMethodParameter], true)}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${groupedMarginalContributorsQueryFragment([includeNotHeldParameter, attributionMethodParameter])}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function groupedMarginalContributorsQueryFragment(parameters = []) {
  return `groupedRiskContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}) {
    id
    name
    exposureRiskCorrelation{
      volatility
      correlation
      marginalContribution
      riskContribution
    }
    attribution {
      exposureRiskCorrelation{
        factors{
          volatility
          correlation
          marginalContribution
          riskContribution
        }
        specific{
          volatility
          correlation
          marginalContribution
          riskContribution
        }
      }
    }
    contributors{
      ${getContributorDescriptors()}
      total
      attribution {
        exposureRiskCorrelation{
          factors{
            volatility
            correlation
            marginalContribution
            riskContribution
          }
          specific{
            volatility
            correlation
            marginalContribution
            riskContribution
          }
        }
      }
    }
  }`
}
